// Permission keys — must match backend/app/Support/Permissions.php
export const P = {
  TENANT_MANAGE: 'tenant.manage',
  TENANT_VIEW: 'tenant.view',
  BILLING_MANAGE: 'billing.manage',
  ROLES_MANAGE: 'roles.manage',
  USERS_MANAGE: 'users.manage',
  ORG_MANAGE: 'org.manage',
  ORG_VIEW: 'org.view',
  EMPLOYEES_MANAGE: 'employees.manage',
  EMPLOYEES_VIEW: 'employees.view',
  EMPLOYEES_TEAM: 'employees.team',
  SENSITIVE_VIEW: 'employees.sensitive',
  ATTENDANCE_MANAGE: 'attendance.manage',
  ATTENDANCE_VIEW: 'attendance.view',
  ATTENDANCE_TEAM: 'attendance.team',
  LEAVE_MANAGE: 'leave.manage',
  LEAVE_VIEW: 'leave.view',
  LEAVE_TEAM: 'leave.team',
  PAYROLL_MANAGE: 'payroll.manage',
  PAYROLL_VIEW: 'payroll.view',
  REPORTS_FULL: 'reports.full',
  REPORTS_PAYROLL: 'reports.payroll',
  REPORTS_TEAM: 'reports.team',
  AUDIT_VIEW: 'audit.view',
  WORKFLOW_MANAGE: 'workflow.manage',
  HELPDESK_MANAGE: 'helpdesk.manage',
  SELF_SERVICE: 'ess.self',
} as const;

export type PermissionKey = (typeof P)[keyof typeof P];

export const can = (perms: string[] | undefined, ...keys: string[]) => !!perms && keys.some((k) => perms.includes(k));
